/**
 * De naam van een regel, of de reden waarom er geen naam is.
 *
 * Eén plek, sinds story 33.3. Dezelfde vier regels stonden daarvóór op DRIE plekken —
 * `BehandeltijdPerPersoon.tsx`, `Aandachtslijst.tsx` en `BehandeltijdTabel.tsx` — en met de kaart
 * over de verdeling over de mensen erbij zouden het er vier zijn geworden. Kopieën van dezelfde
 * afspraak lopen uiteen; deze afspraak mag dat niet, want hij gaat over hoe iemand op het scherm
 * heet. Alle vier de plekken lezen nu deze functie.
 *
 * Nooit een leeg veld en nooit een verzonnen "onbekende gebruiker": de uitkomsten zonder naam
 * houden elk hun eigen tekst, en een uitkomst die dit portaal nog niet kent valt terug op de code
 * zelf — zichtbaar en navraagbaar, in plaats van stil te verdwijnen.
 */

/** Wat er van een regel nodig is om hem te benoemen; meer wordt er niet gelezen. */
export interface TeBenoemen {
  /** Alleen aanwezig bij `named`. Nooit invullen met een verzonnen waarde. */
  userName?: string;
  userNameOutcome: string;
}

/** De vertaalfunctie zoals `react-i18next` hem geeft, tot precies wat hier gebruikt wordt beperkt. */
type Vertaal = (key: string, options?: Record<string, unknown>) => string;

export function naamVoorRegel(regel: TeBenoemen, t: Vertaal): string {
  if (regel.userNameOutcome === 'named' && regel.userName != null && regel.userName !== '') return regel.userName;
  const vertaald = t(`handlingTime.nameOutcome.${regel.userNameOutcome}`, { defaultValue: '' });
  return vertaald !== '' ? vertaald : t('handlingTime.nameOutcome.unknownOutcome', { outcome: regel.userNameOutcome });
}
